export default __webpack_public_path__ + "static/media/ArticleDesktop.d4e63e48.png";